import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 20l-.8-.6 5.7-6.4L12 6.6l.8-.6 6.2 7z"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref);
}

export default "data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg'%3E %3Cpolygon points='12.8,20 12,19.4 17.7,13 12,6.6 12.8,6 19,13'/%3E %3C/svg%3E";
export { SvgArrow as ReactComponent };